import { useSyncExternalStore } from 'react';

// The same test as Tailwind's `landscap` variant (see `tailwind.config.js`), read from JS because
// the shell has to choose a different tree in landscape, not just different classes: portrait is one
// swipeable track of three panels, landscape is a left rail with one panel mounted. The redesign is
// portrait-only by decision, so landscape keeps the arrangement it already had.
const QUERY = '(max-height: 500px) and (min-aspect-ratio: 16/10)';

const query = typeof window === 'undefined' ? null : window.matchMedia(QUERY);

const subscribe = (callback: () => void) => {
  query?.addEventListener('change', callback);
  return () => query?.removeEventListener('change', callback);
};

export default function usePhoneLandscape() {
  return useSyncExternalStore(
    subscribe,
    () => query?.matches ?? false,
    () => false,
  );
}
